// Used in idle-checker.component.ts

// Angular
import {
    Component,
    OnInit,
    OnDestroy,
    ChangeDetectorRef,
    ChangeDetectionStrategy,
} from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { Idle } from "@ng-idle/core";

// RXJS/Store
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
    selector: "idle-checker-dialog",
    templateUrl: "./idle-checker-dialog.component.html",
    styleUrls: ["./idle-checker-dialog.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class IdleCheckerDialogComponent implements OnInit, OnDestroy {
    timeoutCountdown = this.idle.getTimeout();
    timeoutMinutes = 5;
    timeoutSeconds = 0;
    private ngUnsubscribe = new Subject();

    constructor(
        public dialog: MatDialogRef<IdleCheckerDialogComponent>,
        private idle: Idle,
        private cdr: ChangeDetectorRef
    ) {}

    ngOnInit() {
        this.idle.onTimeoutWarning
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((countdown: number) => {
                // Value only goes to 1, 0 is not viewed since it means timeout
                this.timeoutCountdown = countdown;
                this.timeoutMinutes = Math.floor(countdown / 60);
                this.timeoutSeconds = countdown - this.timeoutMinutes * 60;
                this.cdr.detectChanges();
            });

        this.idle.onTimeout
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(() => {
                this.timeoutCountdown = 0;
                this.timeoutMinutes = 0;
                this.timeoutSeconds = 0;
                this.cdr.detectChanges();
                this.dialog.close(false);
            });
    }

    ngOnDestroy(): void {
        this.ngUnsubscribe.next(true);
        this.ngUnsubscribe.complete();
    }

    keepMeLoggedIn() {
        this.dialog.close(true); // true to indicate keep user logged in
    }

    logout(): void {
        this.dialog.close(false); // false to indicate need to log user out
    }
}
